import { z } from 'zod';

export const MAX_FACT_CONTENT = 200;

export const createFactSchema = z.object({
  content: z.string().trim().min(1).max(MAX_FACT_CONTENT),
});

export type CreateFactInput = z.infer<typeof createFactSchema>;
